import * as React from "react";
import { Box, Button, FormControl, FormControlLabel, TextField, Typography, Checkbox, Select, MenuItem, InputLabel, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import Axios from 'axios';
import Alert from '../../components/alert/Alert';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Backdrop from "../../components/Backdrop";
import IconButton from '@mui/material/IconButton';
import { FileUploadOutlined, AutoAwesome } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import HiddenPDF from '../hwQuestions/HiddenPDF';
import { Document, Page, pdfjs } from "react-pdf";
import { Autocomplete } from "@mui/material";
import { useTestCategories } from "../../utils/TestCategory";
import QuestionPreviewForTest from "./QuestionPreviewForTest";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getAuthHeader } from '../../utils/authToken';
import TestPreviewDialog from '../../components/TestPreviewDialog';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const AP_EXAM_FORMATS = [
    { label: 'AP African American Studies', group: 'Fully Digital' },
    { label: 'AP Art History', group: 'Fully Digital' },
    { label: 'AP Comparative Government and Politics', group: 'Fully Digital' },
    { label: 'AP Computer Science A', group: 'Fully Digital' },
    { label: 'AP Computer Science Principles', group: 'Fully Digital' },
    { label: 'AP English Language and Composition', group: 'Fully Digital' },
    { label: 'AP English Literature and Composition', group: 'Fully Digital' },
    { label: 'AP Environmental Science', group: 'Fully Digital' },
    { label: 'AP European History', group: 'Fully Digital' },
    { label: 'AP Human Geography', group: 'Fully Digital' },
    { label: 'AP Latin', group: 'Fully Digital' },
    { label: 'AP Psychology', group: 'Fully Digital' },
    { label: 'AP Seminar', group: 'Fully Digital' },
    { label: 'AP United States Government and Politics', group: 'Fully Digital' },
    { label: 'AP United States History', group: 'Fully Digital' },
    { label: 'AP World History: Modern', group: 'Fully Digital' },
    { label: 'AP Biology', group: 'Hybrid Digital' },
    { label: 'AP Calculus AB', group: 'Hybrid Digital' },
    { label: 'AP Calculus BC', group: 'Hybrid Digital' },
    { label: 'AP Chemistry', group: 'Hybrid Digital' },
    { label: 'AP Macroeconomics', group: 'Hybrid Digital' },
    { label: 'AP Microeconomics', group: 'Hybrid Digital' },
    { label: 'AP Physics 1: Algebra-Based', group: 'Hybrid Digital' },
    { label: 'AP Physics 2: Algebra-Based', group: 'Hybrid Digital' },
    { label: 'AP Physics C: Electricity and Magnetism', group: 'Hybrid Digital' },
    { label: 'AP Physics C: Mechanics', group: 'Hybrid Digital' },
    { label: 'AP Precalculus', group: 'Hybrid Digital' },
    { label: 'AP Statistics', group: 'Hybrid Digital' },
];

const AddTest = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Fetch test categories from API
    const { categories: tests, loading: categoriesLoading } = useTestCategories();

    const [successAlertOpen, setSuccessAlertOpen] = React.useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
    const [successAlertMessage, setSuccessAlertMessage] = React.useState("");
    const [errorAlertMessage, setErrorAlertMessage] = React.useState("");
    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [backdropOpen, setBackdropOpen] = React.useState(false);
    const handleBackdropClose = () => {
        setBackdropOpen(false);
    };

    const [file, setFile] = React.useState(null);
    const [explanationFile, setExplanationFile] = React.useState(null);
    const [teacherFile, setTeacherFile] = React.useState(null);

    const [previewCardToggle, setPreviewCardToggle] = React.useState(false);
    const [previewDialogOpen, setPreviewDialogOpen] = React.useState(false);

    // const [options, setOptions] = React.useState([]);
    // const [answers, setAnswers] = React.useState([]);
    // const [numAnswers, setNumAnswers] = React.useState(1);

    // Input fields for creating new sections (separate from preview)
    const [optionName, setOptionName] = React.useState(['A', 'B', 'C', 'D']);
    const [numChoices, setNumChoices] = React.useState(4);

    // Preview state (derived from selected section/sample)
    const [previewOptionName, setPreviewOptionName] = React.useState(['A', 'B', 'C', 'D']);
    const [previewNumChoices, setPreviewNumChoices] = React.useState(4);

    const [subject, setSubject] = React.useState(null);
    const [isSection, setIsSection] = React.useState(null);
    const [sectionCreated, setSectionCreated] = React.useState(false);
    const [sampleCreated, setSampleCreated] = React.useState(false);

    const [numQuestions, setNumQuestions] = React.useState('');

    const [sections, setSections] = React.useState([]);
    const [sample, setSample] = React.useState([]);

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [sectionToDelete, setSectionToDelete] = React.useState(null);
    const [releaseGrades, setReleaseGrades] = React.useState(false);
    const [useActStyleChoices, setUseActStyleChoices] = React.useState(false);

    // FRQ mode toggle
    const [isFrqMode, setIsFrqMode] = React.useState(false);

    // SA (Short Answer) mode toggle
    const [isSaMode, setIsSaMode] = React.useState(false);

    // FRQ rubric state (test-level — one rubric for all FRQ questions)
    const [rubricFile, setRubricFile] = React.useState(null); // new File upload
    const [selectedRubricId, setSelectedRubricId] = React.useState(''); // existing rubric id
    const [existingRubrics, setExistingRubrics] = React.useState([]);

    // AI auto-fill dialog
    const [aiDialogOpen, setAiDialogOpen] = React.useState(false);
    const [aiResponseText, setAiResponseText] = React.useState('');
    const [aiAutoFillLoading, setAiAutoFillLoading] = React.useState(false);

    // Auto-fill confirmation modal
    const [autoFillModalOpen, setAutoFillModalOpen] = React.useState(false);
    const [autoFillSendTest, setAutoFillSendTest] = React.useState(true);
    const [autoFillSendAnswerKey, setAutoFillSendAnswerKey] = React.useState(true);
    const [autoFillSendRubric, setAutoFillSendRubric] = React.useState(true);

    // Track which section is selected for preview updates (null = none, number = section index)
    const [selectedSectionIndex, setSelectedSectionIndex] = React.useState(null);

    const handleClickDialogOpen = (index) => {
        setSectionToDelete(index);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDeleteSection = () => {
        const updatedSections = sections.filter((_, index) => index !== sectionToDelete);
        const reIndexedSections = updatedSections.map((section, index) => {
            return {
                ...section,
                sectionNumber: index + 1,
            };
        });
        setSections(reIndexedSections);
        handleDialogClose();

        // Clear selection if the deleted section was selected, or adjust index if needed
        if (selectedSectionIndex === sectionToDelete) {
            setSelectedSectionIndex(null);
        } else if (selectedSectionIndex !== null && selectedSectionIndex > sectionToDelete) {
            setSelectedSectionIndex(selectedSectionIndex - 1);
        }

        if (reIndexedSections.length === 0) {
            setSectionCreated(false);
            setSelectedSectionIndex(null);
        }
    };

    const handleDragEnd = (result) => {
        const { destination, source } = result;

        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        const currentSections = Array.from(sections);
        const [removed] = currentSections.splice(source.index, 1);
        currentSections.splice(destination.index, 0, removed);

        const reorderedSections = currentSections.map((section, index) => ({
            ...section,
            sectionNumber: index + 1
        }));

        setSections(reorderedSections);

        // Update selected section index if needed
        if (selectedSectionIndex !== null) {
            if (selectedSectionIndex === source.index) {
                setSelectedSectionIndex(destination.index);
            } else if (source.index < selectedSectionIndex && destination.index >= selectedSectionIndex) {
                setSelectedSectionIndex(selectedSectionIndex - 1);
            } else if (source.index > selectedSectionIndex && destination.index <= selectedSectionIndex) {
                setSelectedSectionIndex(selectedSectionIndex + 1);
            }
        }
    };

    const handleUpload = (event) => {
        setFile(event.target.files[0]);
    };

    const handleFileRemove = (event) => {
        event.preventDefault();
        setFile(null);
    };

    const handleExplanationUpload = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile && uploadedFile.type === "application/pdf") {
            setExplanationFile(uploadedFile);
        } else {
            setErrorAlertMessage("Please upload a PDF file for explanation");
            setErrorAlertOpen(true);
        }
    };

    const handleExplanationFileRemove = (event) => {
        event.preventDefault();
        setExplanationFile(null);
    };

    const handleTeacherFileUpload = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile && uploadedFile.type === "application/pdf") {
            setTeacherFile(uploadedFile);
        } else {
            setErrorAlertMessage("Please upload a PDF file");
            setErrorAlertOpen(true);
        }
    };

    const handleTeacherFileRemove = (event) => {
        event.preventDefault();
        setTeacherFile(null);
    };

    // Toggle all FRQ parts to upload or text
    const handleToggleAllFrqUpload = (toUpload) => {
        const updateQuestions = (questions) => {
            return questions.map(q => {
                if (q.question_type !== 'frq') return q;
                if (toUpload) {
                    if (q.frq_parts && q.frq_parts.length > 0) {
                        return { ...q, frq_parts: q.frq_parts.map(p => ({ ...p, part_type: 'upload' })) };
                    }
                    return { ...q, frq_type: 'upload' };
                } else {
                    if (q.frq_parts && q.frq_parts.length > 0) {
                        return { ...q, frq_parts: q.frq_parts.map(p => ({ ...p, part_type: 'text' })) };
                    }
                    return { ...q, frq_type: 'saq' };
                }
            });
        };

        if (isSection?.value === "With Section") {
            setSections(prev => prev.map(s => {
                const key = s.test_questions ? 'test_questions' : 'questions';
                return { ...s, [key]: updateQuestions(s[key] || []) };
            }));
        } else {
            setSample(prev => {
                if (Array.isArray(prev)) return updateQuestions(prev);
                return { ...prev, questions: updateQuestions(prev.questions || []) };
            });
        }
    };

    const AI_PROMPT = `You are an expert at analyzing test PDFs and extracting their full structure (MCQ, FRQ, and Short Answer).

Analyze the uploaded test PDF and extract ALL sections and questions.

IMPORTANT: Use COMPACT format to save tokens. Only include fields relevant to each question type.

MCQ: {"n": 1, "t": "mcq", "a": "A"}  (add "nc": 5 only if not 4 choices, "ms": true only if multi-select)
SA:  {"n": 1, "t": "sa", "a": "answer", "aa": ["answer", "variant"]}
FRQ: {"n": 1, "t": "frq", "ft": "saq", "mp": 3, "fp": [{"pl": "a", "mp": 1}]}  (ft=frq_type, mp=max_points, fp=frq_parts, add "cg": 1 for choice_group)

Return: {"sections": [{"name": "Section name", "questions": [...]}]}
Extract ALL questions. Return ONLY valid JSON.`;

    const handleApplyAiResponse = () => {
        try {
            const jsonStr = aiResponseText.trim().replace(/^```(?:json)?\n?/, "").replace(/\n?```$/, "");
            const data = JSON.parse(jsonStr);

            if (!data.sections || data.sections.length === 0) {
                setErrorAlertMessage("No sections found in the response");
                setErrorAlertOpen(true);
                return;
            }

            // Expand compact format if needed
            for (const section of data.sections) {
                section.questions = (section.questions || []).map(q => {
                    if (q.question_type) return q;
                    return {
                        question_number: q.n, question_type: q.t, answer: q.a || '',
                        num_choices: q.nc || 4, is_multi_select: q.ms || false,
                        frq_type: q.ft || null, max_points: q.mp || null,
                        frq_parts: q.fp ? q.fp.map(p => ({ part_label: p.pl, max_points: p.mp, ...(p.pt && { part_type: p.pt }) })) : null,
                        choice_group: q.cg || null, accepted_answers: q.aa || null,
                    };
                });
            }

            const hasFrq = data.sections.some(s => s.questions.some(q => q.question_type === 'frq'));
            const hasSa = data.sections.some(s => s.questions.some(q => q.question_type === 'sa'));
            if (hasFrq) setIsFrqMode(true);
            if (hasSa) setIsSaMode(true);

            const buildQuestion = (q) => {
                if (q.question_type === 'sa') {
                    return {
                        questionNumber: q.question_number,
                        question_type: 'sa',
                        answer: q.answer || '',
                        accepted_answers: q.accepted_answers || [''],
                        max_points: 1,
                        choices: [],
                    };
                }
                if (q.question_type === 'frq') {
                    return {
                        questionNumber: q.question_number,
                        question_type: 'frq',
                        frq_type: q.frq_type || 'saq',
                        max_points: q.max_points || 0,
                        frq_parts: q.frq_parts || null,
                        choice_group: q.choice_group || null,
                        rubric_id: null,
                        choices: [],
                        answer: '',
                    };
                }
                const nc = q.num_choices || 4;
                const choiceLabels = ['A','B','C','D','E','F','G','H','I','J'];
                return {
                    questionNumber: q.question_number,
                    question_type: 'mcq',
                    is_multi_select: q.is_multi_select || false,
                    isMultiSelect: q.is_multi_select || false,
                    choices: Array.from({ length: nc }, (_, i) => ({
                        choiceNumber: i + 1,
                        choice: choiceLabels[i] || String(i + 1),
                    })),
                    answer: q.answer || '',
                };
            };

            const allQuestions = data.sections.flatMap(s => s.questions.map(buildQuestion));

            if (isSection?.value === "With Section") {
                const newSections = data.sections.map((section, sIdx) => ({
                    sectionNumber: sIdx + 1,
                    sectionName: section.name || `Section ${sIdx + 1}`,
                    numQuestions: section.questions.length,
                    questions: section.questions.map(buildQuestion),
                }));
                setSections(newSections);
                setSectionCreated(true);
                setSelectedSectionIndex(0);
            } else {
                setSample({ questions: allQuestions });
                setSampleCreated(true);
                setSelectedSectionIndex(0);
            }

            setAiDialogOpen(false);
            setAiResponseText('');
            setSuccessAlertMessage("Test structure applied successfully");
            setSuccessAlertOpen(true);
        } catch (err) {
            console.error("JSON parse error:", err);
            setErrorAlertMessage("Invalid JSON. Make sure the AI response is valid JSON.");
            setErrorAlertOpen(true);
        }
    };

    const handleOneClickAutoFill = async () => {
        setAutoFillModalOpen(false);
        const sendTest = autoFillSendTest && file;
        const sendKey = autoFillSendAnswerKey && rubricFile;
        const selectedRubric = autoFillSendRubric && selectedRubricId
            ? existingRubrics.find(r => r.id === parseInt(selectedRubricId) || r.id === selectedRubricId)
            : null;

        if (!sendTest && !sendKey && !selectedRubric) {
            setErrorAlertMessage("Select at least one file to send");
            setErrorAlertOpen(true);
            return;
        }
        setAiAutoFillLoading(true);
        try {
            const formData = new FormData();
            if (sendTest) formData.append('file', file);
            if (sendKey) formData.append('answerKey', rubricFile);
            if (isSaMode) formData.append('saMode', 'true');
            if (selectedRubric && selectedRubric.rubric_text) {
                formData.append('rubricText', selectedRubric.rubric_text);
            }
            const response = await Axios.post(
                `${process.env.REACT_APP_URL}/api/v1/tests/analyze-pdf`,
                formData,
                {
                    headers: {
                        Authorization: getAuthHeader(),
                        'Content-Type': 'multipart/form-data',
                    },
                    timeout: 120000, // 2 min — GPT-4o can take a while on large PDFs
                }
            );
            // The response is the parsed JSON structure — apply it like paste
            setAiResponseText(JSON.stringify(response.data));
            // Reuse the same apply logic
            const data = response.data;

            if (!data.sections || data.sections.length === 0) {
                setErrorAlertMessage("AI could not extract any sections from the PDF");
                setErrorAlertOpen(true);
                return;
            }

            const hasFrq = data.sections.some(s => s.questions.some(q => q.question_type === 'frq'));
            const hasSa = data.sections.some(s => s.questions.some(q => q.question_type === 'sa'));
            if (hasFrq) setIsFrqMode(true);
            if (hasSa) setIsSaMode(true);

            const buildQuestion = (q) => {
                if (q.question_type === 'sa') {
                    return {
                        questionNumber: q.question_number,
                        question_type: 'sa',
                        answer: q.answer || '',
                        accepted_answers: q.accepted_answers || [''],
                        max_points: 1,
                        choices: [],
                    };
                }
                if (q.question_type === 'frq') {
                    return {
                        questionNumber: q.question_number,
                        question_type: 'frq',
                        frq_type: q.frq_type || 'saq',
                        max_points: q.max_points || 0,
                        frq_parts: q.frq_parts || null,
                        choice_group: q.choice_group || null,
                        rubric_id: null,
                        choices: [],
                        answer: '',
                    };
                }
                const nc = q.num_choices || 4;
                const choiceLabels = ['A','B','C','D','E','F','G','H','I','J'];
                return {
                    questionNumber: q.question_number,
                    question_type: 'mcq',
                    is_multi_select: q.is_multi_select || false,
                    isMultiSelect: q.is_multi_select || false,
                    choices: Array.from({ length: nc }, (_, i) => ({
                        choiceNumber: i + 1,
                        choice: choiceLabels[i] || String(i + 1),
                    })),
                    answer: q.answer || '',
                };
            };

            // Flatten all questions from all GPT-4o sections
            const allQuestions = data.sections.flatMap(s => s.questions.map(buildQuestion));

            if (isSection?.value === "With Section") {
                const newSections = data.sections.map((section, sIdx) => ({
                    sectionNumber: sIdx + 1,
                    sectionName: section.name || `Section ${sIdx + 1}`,
                    numQuestions: section.questions.length,
                    questions: section.questions.map(buildQuestion),
                }));
                setSections(newSections);
                setSectionCreated(true);
                setSelectedSectionIndex(0);
            } else {
                setSample({ questions: allQuestions });
                setSampleCreated(true);
                setSelectedSectionIndex(0);
            }

            setAiDialogOpen(false);
            setSuccessAlertMessage("Test structure auto-filled from PDF");
            setSuccessAlertOpen(true);
        } catch (err) {
            console.error("Auto-fill error:", err);
            setErrorAlertMessage(err.response?.data?.error || "Failed to analyze PDF with AI");
            setErrorAlertOpen(true);
        } finally {
            setAiAutoFillLoading(false);
        }
    };

    const documentRender = () => {
        // Use devicePixelRatio to render crisp PDFs on high-DPI displays (Windows scaling, Retina, etc.)
        // Minimum scale of 2 ensures crisp rendering even at DPR 1
        const pixelRatio = Math.max(window.devicePixelRatio || 1, 2);

        return (
            <Document
                file={file}
                onContextMenu={(e) => e.preventDefault()}
                className="pdf-container"
            >
                <div>
                    <Page
                        pageNumber={1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        scale={pixelRatio}
                    />
                </div>
            </Document>
        );
    };

    const handleCreateSection = () => {

        if (!numQuestions || numQuestions === '0') {
            setErrorAlertMessage("Please enter a valid number of questions");
            setErrorAlertOpen(true);
            return;
        }

        if (!isFrqMode && !isSaMode && (!numChoices || numChoices === '0')) {
            setErrorAlertMessage("Please enter a valid number of choices");
            setErrorAlertOpen(true);
            return;
        }

        const newSection = {
            sectionNumber: sections.length + 1,
            questions: [],
            numQuestions: numQuestions,
        };

        if (isSaMode) {
            for (let i = 0; i < numQuestions; i++) {
                newSection.questions.push({
                    questionNumber: i + 1,
                    question_type: 'sa',
                    answer: '',
                    accepted_answers: [''],
                    max_points: 1,
                    choices: [],
                });
            }
        } else if (isFrqMode) {
            for (let i = 0; i < numQuestions; i++) {
                newSection.questions.push({
                    questionNumber: i + 1,
                    question_type: 'frq',
                    frq_type: 'saq',
                    max_points: 3,
                    frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}],
                    choice_group: null,
                    rubric_id: null,
                    choices: [],
                    answer: '',
                });
            }
        } else if (useActStyleChoices) {
            // ACT-style alternating choices
            for (let i = 0; i < numQuestions; i++) {
                let actOptions;
                if (numChoices === '4' || numChoices === 4) {
                    actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
                } else if (numChoices === '5' || numChoices === 5) {
                    actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
                } else {
                    const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                    actOptions = i % 2 === 0 ? standardOptions.slice(0, numChoices) : evenOptions.slice(0, numChoices);
                }

                const newQuestion = {
                    questionNumber: i + 1,
                    choices: [],
                    answer: "",
                };

                for (let j = 0; j < numChoices; j++) {
                    newQuestion.choices.push({
                        choiceNumber: j + 1,
                        choice: actOptions[j],
                    });
                }

                newSection.questions.push(newQuestion);
            }
        } else {
            for (let i = 0; i < numQuestions; i++) {
                const newQuestion = {
                    questionNumber: i + 1,
                    choices: [],
                    answer: "",
                };

                for (let j = 0; j < numChoices; j++) {
                    newQuestion.choices.push({
                        choiceNumber: j + 1,
                        choice: optionName[j],
                    });
                }
                newSection.questions.push(newQuestion);
            }
        }
        setSections([...sections, newSection]);
        setSectionCreated(true);
        // Auto-select the newly created section
        setSelectedSectionIndex(sections.length);
    };
    

    const handleCreateSample = () => {

        if (!numQuestions || numQuestions === '0') {
            setErrorAlertMessage("Please enter a valid number of questions");
            setErrorAlertOpen(true);
            return;
        }

        if (!isFrqMode && !isSaMode && (!numChoices || numChoices === '0')) {
            setErrorAlertMessage("Please enter a valid number of choices");
            setErrorAlertOpen(true);
            return;
        }

        const newSample = {
            questions: [],
            numQuestions: numQuestions,
        };

        if (isSaMode) {
            for (let i = 0; i < numQuestions; i++) {
                newSample.questions.push({
                    questionNumber: i + 1,
                    question_type: 'sa',
                    answer: '',
                    accepted_answers: [''],
                    max_points: 1,
                    choices: [],
                });
            }
        } else if (isFrqMode) {
            for (let i = 0; i < numQuestions; i++) {
                newSample.questions.push({
                    questionNumber: i + 1,
                    question_type: 'frq',
                    frq_type: 'saq',
                    max_points: 3,
                    frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}],
                    choice_group: null,
                    rubric_id: null,
                    choices: [],
                    answer: '',
                });
            }
        } else if (useActStyleChoices) {
            // ACT-style alternating choices
            for (let i = 0; i < numQuestions; i++) {
                let actOptions;
                if (numChoices === '4' || numChoices === 4) {
                    actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
                } else if (numChoices === '5' || numChoices === 5) {
                    actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
                } else {
                    const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                    actOptions = i % 2 === 0 ? standardOptions.slice(0, numChoices) : evenOptions.slice(0, numChoices);
                }

                const newQuestion = {
                    questionNumber: i + 1,
                    choices: [],
                    answer: "",
                };

                for (let j = 0; j < numChoices; j++) {
                    newQuestion.choices.push({
                        choiceNumber: j + 1,
                        choice: actOptions[j],
                    });
                }

                newSample.questions.push(newQuestion);
            }
        } else {
            for (let i = 0; i < numQuestions; i++) {
                const newQuestion = {
                    questionNumber: i + 1,
                    choices: [],
                    answer: "",
                };

                for (let j = 0; j < numChoices; j++) {
                    newQuestion.choices.push({
                        choiceNumber: j + 1,
                        choice: optionName[j],
                    });
                }

                newSample.questions.push(newQuestion);
            }
        }
        setSample(newSample);
        setSampleCreated(true);
        // Auto-select the sample for preview sync
        setSelectedSectionIndex(0);
    };

    const handleDeleteSample = () => {
        setSample([]);
        setSampleCreated(false);
        setSelectedSectionIndex(null);
    };

    const handleSectionAnswerChange = (sectionIndex, questionIndex, choice, isMultiSelect = false) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                const updatedQuestions = section.questions.map((question, qIndex) => {
                    if (qIndex === questionIndex) {
                        if (isMultiSelect) {
                            // Handle multi-select: toggle the choice in comma-separated string
                            const currentAnswers = question.answer ? question.answer.split(',') : [];
                            const choiceIndex = currentAnswers.indexOf(choice);
                            if (choiceIndex > -1) {
                                currentAnswers.splice(choiceIndex, 1);
                            } else {
                                currentAnswers.push(choice);
                            }
                            return { ...question, answer: currentAnswers.join(',') };
                        }
                        return { ...question, answer: choice };
                    }
                    return question;
                });
                return { ...section, questions: updatedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const handleSectionMultiSelectToggle = (sectionIndex, questionIndex) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                const updatedQuestions = section.questions.map((question, qIndex) => {
                    if (qIndex === questionIndex) {
                        return { ...question, isMultiSelect: !question.isMultiSelect, answer: '' };
                    }
                    return question;
                });
                return { ...section, questions: updatedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const handleSampleAnswerChange = (questionIndex, choice, isMultiSelect = false) => {

        const updatedQuestions = sample.questions.map((question, qIndex) => {
            if (qIndex === questionIndex) {
                if (isMultiSelect) {
                    // Handle multi-select: toggle the choice in comma-separated string
                    const currentAnswers = question.answer ? question.answer.split(',') : [];
                    const choiceIndex = currentAnswers.indexOf(choice);
                    if (choiceIndex > -1) {
                        currentAnswers.splice(choiceIndex, 1);
                    } else {
                        currentAnswers.push(choice);
                    }
                    return { ...question, answer: currentAnswers.join(',') };
                }
                return { ...question, answer: choice };
            }
            return question;
        });

        const updatedSample = {
            questions: updatedQuestions,
            numQuestions: numQuestions,
        };

        setSample(updatedSample);
    };

    const handleSampleMultiSelectToggle = (questionIndex) => {
        const updatedQuestions = sample.questions.map((question, qIndex) => {
            if (qIndex === questionIndex) {
                return { ...question, isMultiSelect: !question.isMultiSelect, answer: '' };
            }
            return question;
        });

        const updatedSample = {
            questions: updatedQuestions,
            numQuestions: numQuestions,
        };

        setSample(updatedSample);
    };

    const handleQuestionTypeChange = (sectionIndex, questionIndex, newType) => {
        const buildQuestionForType = (q, type) => {
            if (type === 'frq') {
                return { ...q, question_type: 'frq', frq_type: 'saq', max_points: 3, frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}], answer: '', rubric_id: null, accepted_answers: null };
            } else if (type === 'sa') {
                return { ...q, question_type: 'sa', frq_type: null, max_points: 1, frq_parts: null, rubric_id: null, choice_group: null, answer: '', accepted_answers: [''], isMultiSelect: false, is_multi_select: false, choices: [] };
            } else {
                return { ...q, question_type: 'mcq', frq_type: null, max_points: null, frq_parts: null, rubric_id: null, choice_group: null, answer: '', accepted_answers: null, isMultiSelect: false, is_multi_select: false, num_choices: 4, choices: [{choiceNumber:1,choice:'A'},{choiceNumber:2,choice:'B'},{choiceNumber:3,choice:'C'},{choiceNumber:4,choice:'D'}] };
            }
        };

        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) return buildQuestionForType(q, newType);
                        return q;
                    });
                    return { ...section, questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = sample.questions.map((q, qIdx) => {
                if (qIdx === questionIndex) return buildQuestionForType(q, newType);
                return q;
            });
            setSample({ ...sample, questions: updatedQuestions });
        }
    };

    // Legacy toggle kept for backward compat - cycles MCQ<->FRQ
    const handleQuestionTypeToggle = (sectionIndex, questionIndex) => {
        if (isSection?.value === "With Section") {
            const section = sections[sectionIndex];
            const q = section?.questions?.[questionIndex];
            const currentType = q?.question_type || 'mcq';
            const newType = currentType === 'mcq' ? 'frq' : 'mcq';
            handleQuestionTypeChange(sectionIndex, questionIndex, newType);
        } else {
            const q = sample?.questions?.[questionIndex];
            const currentType = q?.question_type || 'mcq';
            const newType = currentType === 'mcq' ? 'frq' : 'mcq';
            handleQuestionTypeChange(null, questionIndex, newType);
        }
    };

    const updateQuestionFrqField = (sectionIndex, questionIndex, field, value) => {
        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) {
                            const updated = { ...q, [field]: value };
                            // Auto-set max_points and frq_parts when frq_type changes
                            if (field === 'frq_type') {
                                if (value === 'saq') {
                                    updated.max_points = 3;
                                    updated.frq_parts = [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}];
                                } else if (value === 'dbq') {
                                    updated.max_points = 7;
                                    updated.frq_parts = null;
                                } else if (value === 'leq') {
                                    updated.max_points = 6;
                                    updated.frq_parts = null;
                                } else if (value === 'upload') {
                                    updated.max_points = updated.max_points || 3;
                                    if (!updated.frq_parts) {
                                        updated.frq_parts = [{part_label: 'a', max_points: 1, part_type: 'upload'}];
                                    }
                                }
                            }
                            return updated;
                        }
                        return q;
                    });
                    return { ...section, questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = sample.questions.map((q, qIdx) => {
                if (qIdx === questionIndex) {
                    const updated = { ...q, [field]: value };
                    if (field === 'frq_type') {
                        if (value === 'saq') {
                            updated.max_points = 3;
                            updated.frq_parts = [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}];
                        } else if (value === 'dbq') {
                            updated.max_points = 7;
                            updated.frq_parts = null;
                        } else if (value === 'leq') {
                            updated.max_points = 6;
                            updated.frq_parts = null;
                        } else if (value === 'upload') {
                            updated.max_points = updated.max_points || 3;
                            if (!updated.frq_parts) {
                                updated.frq_parts = [{part_label: 'a', max_points: 1, part_type: 'upload'}];
                            }
                        }
                    }
                    return updated;
                }
                return q;
            });
            setSample({ ...sample, questions: updatedQuestions });
        }
    };

    const updateFrqParts = (sectionIndex, questionIndex, newParts) => {
        const totalPoints = newParts.reduce((sum, p) => sum + (p.max_points || 0), 0);
        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) return { ...q, frq_parts: newParts, max_points: totalPoints };
                        return q;
                    });
                    return { ...section, questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = sample.questions.map((q, qIdx) => {
                if (qIdx === questionIndex) return { ...q, frq_parts: newParts, max_points: totalPoints };
                return q;
            });
            setSample({ ...sample, questions: updatedQuestions });
        }
    };

    const handleSectionNameChange = (event, index) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === index) {
                return { ...section, section_name: event.target.value };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const handleFormSubmit = async (values) => {
        setBackdropOpen(true);
    
        if (isSection && isSection.value === "With Section" && !sectionCreated) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("At least one section is necessary");
            setBackdropOpen(false);
            return;
        }
    
        if (isSection && isSection.value === "No Section" && !sampleCreated) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("At least one sample is necessary");
            setBackdropOpen(false);
            return;
        }
    
        if (!file || file.type !== "application/pdf") {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please upload a pdf file");
            setBackdropOpen(false);
            return;
        }
    
        if (!subject) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please select subjects");
            setBackdropOpen(false);
            return;
        }
    
        if (!isSection) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please select with section or no section");
            setBackdropOpen(false);
            return;
        }
    
        // Skip numQuestions/numChoices validation if sections or sample were populated (e.g. via AI auto-fill)
        if (!sectionCreated && !sampleCreated) {
            if (!numQuestions || (!isFrqMode && !isSaMode && !numChoices)) {
                setErrorAlertOpen(true);
                setErrorAlertMessage((isFrqMode || isSaMode) ? "Please enter the number of questions" : "Please enter the number of questions and choices");
                setBackdropOpen(false);
                return;
            }
        }
    
        const formData = new FormData();
        formData.append('file', file);
        formData.append('subject', subject.value);
        formData.append('isSection', isSection ? isSection.value : '');
        formData.append('release_grades', releaseGrades.toString());
        formData.append('has_special_choices', useActStyleChoices.toString());
        if (explanationFile) {
            formData.append('explanationFile', explanationFile);
        }
        if (teacherFile) {
            formData.append('teacherFile', teacherFile);
        }

        // Rubric: either upload new file or reference existing
        if (rubricFile) {
            formData.append('rubricFile', rubricFile);
        } else if (selectedRubricId) {
            formData.append('rubricId', selectedRubricId.toString());
        }

        if (isSection.value === "With Section") {
            formData.append('sections', JSON.stringify(sections));
        } else {
            formData.append('sample', JSON.stringify(sample));
        }
    
        await Axios.post(`${process.env.REACT_APP_URL}/api/v1/tests`, formData, {
            headers: {
                Authorization: getAuthHeader(),
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            setSuccessAlertMessage(response.data.message);
            setSuccessAlertOpen(true);
            handleBackdropClose();
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }).catch((error) => {
            console.log(error);
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
            setErrorAlertOpen(true);
            handleBackdropClose();
        });
    };

    React.useEffect(() => {
        localStorage.setItem('selectedMenu', 'Add Test');
        // Fetch existing rubrics for dropdown
        Axios.get(`${process.env.REACT_APP_URL}/api/v1/test-rubrics`, {
            headers: { Authorization: getAuthHeader() },
        }).then(res => setExistingRubrics(res.data)).catch(() => {});
    }, []);

    // Sync preview with selected section's/sample's choices when selection changes
    React.useEffect(() => {
        if (isSection?.value === "With Section" && selectedSectionIndex !== null && sections[selectedSectionIndex]) {
            const selectedSection = sections[selectedSectionIndex];
            const sectionChoices = selectedSection.questions[0]?.choices || [];

            const newNumChoices = sectionChoices.length;

            if (newNumChoices > 0) {
                setPreviewNumChoices(newNumChoices);
                if (useActStyleChoices) {
                    // For ACT: set placeholder names matching the section's choice count
                    // so preview renders correct number of fields and sync effect has correct length
                    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    setPreviewOptionName(letters.slice(0, newNumChoices));
                } else {
                    setPreviewOptionName(sectionChoices.map(c => c.choice));
                }
            }
        }

        // For "No Section" mode: sync preview with sample when selected
        if (isSection?.value === "No Section" && selectedSectionIndex === 0 && sample?.questions?.[0]) {
            const sampleChoices = sample.questions[0]?.choices || [];

            const newNumChoices = sampleChoices.length;

            if (newNumChoices > 0) {
                setPreviewNumChoices(newNumChoices);
                if (useActStyleChoices) {
                    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    setPreviewOptionName(letters.slice(0, newNumChoices));
                } else {
                    setPreviewOptionName(sampleChoices.map(c => c.choice));
                }
            }
        }
    }, [selectedSectionIndex, sample, sections, isSection, useActStyleChoices]);

    // Use refs to access current values without adding to dependencies (prevents loops)
    const sampleRef = React.useRef(sample);
    const sectionsRef = React.useRef(sections);
    const isSectionRef = React.useRef(isSection);
    const sampleCreatedRef = React.useRef(sampleCreated);
    const selectedSectionIndexRef = React.useRef(selectedSectionIndex);
    const useActStyleChoicesRef = React.useRef(useActStyleChoices);

    React.useEffect(() => {
        sampleRef.current = sample;
        sectionsRef.current = sections;
        isSectionRef.current = isSection;
        sampleCreatedRef.current = sampleCreated;
        selectedSectionIndexRef.current = selectedSectionIndex;
        useActStyleChoicesRef.current = useActStyleChoices;
    }, [sample, sections, isSection, sampleCreated, selectedSectionIndex, useActStyleChoices]);

    // Update selected section/sample when preview options change (names or add/remove)
    // Only triggers on previewOptionName changes (from preview edits)
    React.useEffect(() => {
        const isAct = useActStyleChoicesRef.current;

        const getActChoices = (questionIndex, choiceCount) => {
            if (choiceCount === 4 || choiceCount === '4') {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
            } else if (choiceCount === 5 || choiceCount === '5') {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
            } else {
                const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                return questionIndex % 2 === 0 ? standardOptions.slice(0, choiceCount) : evenOptions.slice(0, choiceCount);
            }
        };

        // Build new choices array — for ACT uses alternating labels per question index
        const buildChoicesArray = (questionIndex) => {
            if (isAct) {
                const actLabels = getActChoices(questionIndex, previewOptionName.length);
                return actLabels.map((label, j) => ({
                    choiceNumber: j + 1,
                    choice: label,
                }));
            }
            return previewOptionName.map((name, j) => ({
                choiceNumber: j + 1,
                choice: name || String.fromCharCode(65 + j),
            }));
        };

        const currentSample = sampleRef.current;
        const currentSections = sectionsRef.current;
        const currentIsSection = isSectionRef.current;
        const currentSampleCreated = sampleCreatedRef.current;
        const currentSelectedSectionIndex = selectedSectionIndexRef.current;

        // For "No Section" mode: automatically update sample when preview changes
        if (currentIsSection?.value === "No Section" && currentSampleCreated && currentSample.questions) {
            const currentChoicesCount = currentSample.questions[0]?.choices?.length || 0;
            const hasCountChanged = currentChoicesCount !== previewOptionName.length;
            const hasNamesChanged = !isAct && currentSample.questions.some((q) =>
                q.choices.some((c, cIdx) => c.choice !== (previewOptionName[cIdx] || c.choice))
            );

            if (hasCountChanged || hasNamesChanged) {
                const updatedQuestions = currentSample.questions.map((question, qIdx) => ({
                    ...question,
                    choices: buildChoicesArray(qIdx),
                }));
                setSample({
                    ...currentSample,
                    questions: updatedQuestions,
                });
            }
        }

        // For "With Section" mode: update selected section when preview changes
        if (currentIsSection?.value === "With Section" && currentSelectedSectionIndex !== null && currentSections[currentSelectedSectionIndex]) {
            const selectedSection = currentSections[currentSelectedSectionIndex];
            const currentChoicesCount = selectedSection.questions[0]?.choices?.length || 0;
            const hasCountChanged = currentChoicesCount !== previewOptionName.length;
            const hasNamesChanged = !isAct && selectedSection.questions.some((q) =>
                q.choices.some((c, cIdx) => c.choice !== (previewOptionName[cIdx] || c.choice))
            );

            if (hasCountChanged || hasNamesChanged) {
                const updatedSections = currentSections.map((section, sIndex) => {
                    if (sIndex === currentSelectedSectionIndex) {
                        const updatedQuestions = section.questions.map((question, qIdx) => ({
                            ...question,
                            choices: buildChoicesArray(qIdx),
                        }));
                        return { ...section, questions: updatedQuestions };
                    }
                    return section;
                });
                setSections(updatedSections);
            }
        }
    }, [previewOptionName]);

    // Retroactively update existing sections/sample when ACT-style checkbox is toggled
    React.useEffect(() => {
        const getActChoices = (questionIndex, choiceCount) => {
            if (choiceCount === '4' || choiceCount === 4) {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
            } else if (choiceCount === '5' || choiceCount === 5) {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
            } else {
                const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                return questionIndex % 2 === 0 ? standardOptions.slice(0, choiceCount) : evenOptions.slice(0, choiceCount);
            }
        };

        const getStandardChoices = (choiceCount) => {
            const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
            return letters.slice(0, choiceCount);
        };

        const rebuildQuestions = (questions) => {
            return questions.map((question, qIndex) => {
                const choiceCount = question.choices.length;
                const newLabels = useActStyleChoices
                    ? getActChoices(qIndex, choiceCount)
                    : getStandardChoices(choiceCount);
                return {
                    ...question,
                    choices: question.choices.map((c, cIdx) => ({
                        ...c,
                        choice: newLabels[cIdx] || c.choice,
                    })),
                };
            });
        };

        // Update all sections
        if (sections.length > 0) {
            const updatedSections = sections.map(section => ({
                ...section,
                questions: rebuildQuestions(section.questions),
            }));
            setSections(updatedSections);
        }

        // Update sample
        if (sample?.questions?.length > 0) {
            setSample({
                ...sample,
                questions: rebuildQuestions(sample.questions),
            });
        }
    }, [useActStyleChoices]);

    return (
        <Box m="20px" marginX={3} marginY={3}>
            <Header title="Add Test" subtitle="A ONE Institute" />
            <Box 
                sx={{ 
                    flexBasis: "50%", 
                    display: "flex", 
                    flexDirection: "column", 
                    gap: "10px", 
                    typography: 'subtitle2',
                    mb: 5
                }}
            >
                <Typography variant="h3" fontWeight="bold">Instructions:</Typography>
                <Typography>1. Fill in the subject, section, number of questions, and choices. You will then see the sample form of a question.</Typography>
                <Typography>2. Write the name of the choice you want. The default values are A, B, C, D.</Typography>
                <Typography>3. Check the sample answer form at the bottom. This will be the question format for your section or test.</Typography>
                <Typography>4-1. If you select "With Section," create the number of sections you need, then fill in the answers for each section.</Typography>
                <Typography>4-2. If you select "No Section," fill in the answers for the sample.</Typography>
                <Typography>5. Create a test. You can find your test in the "Test Library" on the sidebar.</Typography>
            </Box> 
            <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={checkoutSchema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                }) => (
                <form onSubmit={handleSubmit}>
                    <Box
                        padding={4}
                        boxShadow={3}
                        borderRadius={3}
                        m={1}
                        bgcolor={colors.primary[600]}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                            <Typography
                                variant="h4"
                                fontWeight="bold"
                            >
                                Test Information
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={aiAutoFillLoading ? <CircularProgress size={16} color="inherit" /> : <AutoAwesome />}
                                    onClick={() => {
                                        setAutoFillSendTest(!!file);
                                        setAutoFillSendAnswerKey(!!rubricFile);
                                        setAutoFillModalOpen(true);
                                    }}
                                    disabled={(!file && !rubricFile) || aiAutoFillLoading || !subject || !isSection}
                                    color="secondary"
                                >
                                    {aiAutoFillLoading ? 'Analyzing...' : 'Auto-fill from PDF'}
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => setAiDialogOpen(true)}
                                    disabled={!subject || !isSection}
                                >
                                    Paste AI JSON
                                </Button>
                            </Box>
                        </Box>
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                            }}
                        >
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4" }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Files
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            styles={{display:"none"}}
                                            type="file"
                                            hidden
                                            onChange={handleUpload}
                                            name="[licenseFile]"
                                        />
                                    </IconButton>
                                </Box>
                                {file && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {file.name}
                                        </Typography>
                                        <IconButton onClick={(e) => handleFileRemove(e)}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                            {/* Explanation PDF Upload (Optional) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Explanation PDF (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={handleExplanationUpload}
                                        />
                                    </IconButton>
                                </Box>
                                {explanationFile && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {explanationFile.name}
                                        </Typography>
                                        <IconButton onClick={handleExplanationFileRemove}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                            {/* Teacher PDF Upload (Watermarked) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Teacher PDF — Watermarked (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={handleTeacherFileUpload}
                                        />
                                    </IconButton>
                                </Box>
                                {teacherFile && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {teacherFile.name}
                                        </Typography>
                                        <IconButton onClick={handleTeacherFileRemove}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                            {/* Mark all FRQ as Upload toggle */}
                            {isFrqMode && (
                                <Box display="flex" alignItems="center" sx={{ gridColumn: "span 4", mt: 1, gap: 1, flexWrap: 'wrap' }}>
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        All FRQ as Image Upload
                                    </Typography>
                                    <Button size="small" variant="outlined" color="info" onClick={() => handleToggleAllFrqUpload(true)}>
                                        All IMG
                                    </Button>
                                    <Button size="small" variant="outlined" color="warning" onClick={() => handleToggleAllFrqUpload(false)}>
                                        All TXT
                                    </Button>
                                    <Autocomplete
                                        size="small"
                                        sx={{ minWidth: 280 }}
                                        options={AP_EXAM_FORMATS}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, val) => {
                                            if (val) handleToggleAllFrqUpload(val.group === 'Hybrid Digital');
                                        }}
                                        renderInput={(params) => <TextField {...params} label="AP Exam Format" placeholder="Search AP exam..." />}
                                    />
                                </Box>
                            )}
                            {/* Rubric PDF Upload (Optional) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Rubric PDF (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                const f = e.target.files[0];
                                                if (f && f.type === "application/pdf") {
                                                    setRubricFile(f);
                                                    setSelectedRubricId('');
                                                } else {
                                                    setErrorAlertMessage("Please upload a PDF file");
                                                    setErrorAlertOpen(true);
                                                }
                                            }}
                                        />
                                    </IconButton>
                                </Box>
                                {rubricFile && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {rubricFile.name}
                                        </Typography>
                                        <IconButton onClick={(e) => { e.preventDefault(); setRubricFile(null); }}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                                {!rubricFile && (
                                    <FormControl size="small" sx={{ minWidth: 250, ml: 2 }}>
                                        <InputLabel>or select existing rubric</InputLabel>
                                        <Select
                                            value={selectedRubricId}
                                            label="or select existing rubric"
                                            onChange={(e) => setSelectedRubricId(e.target.value)}
                                        >
                                            <MenuItem value="">None</MenuItem>
                                            {existingRubrics.map(r => (
                                                <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </Box>
                            <Autocomplete
                                id="subject-select"
                                options={tests}
                                sx={{ gridColumn: "span 1" }}
                                renderInput={(params) => <TextField {...params} label="Subject" />}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => {
                                    if (newValue !== null && newValue !== undefined) {                                        
                                        setSubject(newValue);
                                    } else {
                                        setSubject(null);
                                        setIsSection(null); // Reset section when subject changes
                                        setSections([]); // Reset sections when subject changes
                                    }
                                }}
                            />
                            {subject !== null && subject.section !== undefined && (
                                <Autocomplete
                                    id="free-solo-demo"
                                    options={subject.section}
                                    sx={{ gridColumn: "span 1" }}
                                    renderInput={(params) => <TextField {...params} label="Section" />}
                                    isOptionEqualToValue={(option, value) => {
                                        return option?.value === value?.value;
                                    }}
                                    value={isSection}
                                    onChange={(event, newValue) => {
                                        if (newValue !== null && newValue !== undefined) {
                                            setIsSection(newValue);
                                        } else {
                                            setIsSection(null);
                                        }
                                    }}
                                />
                            )}
                            <Box sx={{ gridColumn: "span 4" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={releaseGrades}
                                            onChange={(e) => setReleaseGrades(e.target.checked)}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="Release grades to students (students can view their scores)"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isSaMode}
                                            onChange={(e) => { setIsSaMode(e.target.checked); if (e.target.checked) setIsFrqMode(false); }}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="SA (Short Answer — text match grading)"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isFrqMode}
                                            onChange={(e) => { setIsFrqMode(e.target.checked); if (e.target.checked) setIsSaMode(false); }}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="FRQ (Free Response Questions)"
                                />
                                {!isFrqMode && !isSaMode && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={useActStyleChoices}
                                                onChange={(e) => setUseActStyleChoices(e.target.checked)}
                                                sx={{
                                                    color: colors.blueAccent[400],
                                                    '&.Mui-checked': {
                                                        color: colors.blueAccent[400],
                                                    },
                                                }}
                                            />
                                        }
                                        label="ACT-style alternating choices (A,B,C,D for odd / F,G,H,J for even questions)"
                                    />
                                )}
                            </Box>
                            {(isSection && isSection.value) && (
                                <Box sx={{ gridColumn: "span 4", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <TextField
                                        sx={{ width: "80%"}}
                                        // fullWidth
                                        variant="filled"
                                        type="number"
                                        label="Number of Questions"
                                        onBlur={handleBlur}
                                        onChange={(e) => setNumQuestions(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }
                                          }}
                                        value={numQuestions}
                                        name="numQuestions"
                                        error={!!touched.questions && !!errors.questions}
                                        helperText={touched.questions && errors.questions}
                                    />
                                    {!isFrqMode && !isSaMode && (
                                    <TextField
                                        sx={{ width: "80%"}}
                                        // fullWidth
                                        variant="filled"
                                        type="number"
                                        label="Number of Choices"
                                        onBlur={handleBlur}
                                        onChange={(e) => setNumChoices(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }
                                          }}
                                        value={numChoices}
                                        name="numChoices"
                                        error={!!touched.choices && !!errors.choices}
                                        helperText={touched.choices && errors.choices}
                                    />
                                    )}

                            {isSection.value === "With Section" ? (
                                <Button
                                    sx={{ width: "80%" }}
                                    color="secondary"
                                    variant="contained"
                                    onClick={handleCreateSection}
                                >
                                    Create Section
                                </Button>
                            ) : (
                                !sampleCreated ? (
                                    <Button
                                        sx={{ width: "80%" }}
                                        color="secondary"
                                        variant="contained"
                                        onClick={handleCreateSample}
                                    >
                                        Create Sample
                                    </Button>
                                ) : (
                                    <Box sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        mt: 2,
                                        p: 2,
                                        bgcolor: colors.primary[600],
                                        borderRadius: 2,
                                        boxShadow: 3,
                                        border: selectedSectionIndex === 0 ? `3px solid ${colors.blueAccent[400]}` : "3px solid transparent",
                                    }}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Typography variant="h6">Sample</Typography>
                                                {selectedSectionIndex === 0 && (
                                                    <Box
                                                        sx={{
                                                            bgcolor: colors.blueAccent[500],
                                                            color: "white",
                                                            px: 1,
                                                            py: 0.25,
                                                            borderRadius: 1,
                                                            fontSize: "0.7rem",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Selected
                                                    </Box>
                                                )}
                                            </Box>
                                            <ClearIcon
                                                fontSize='small'
                                                color='error'
                                                sx={{ cursor: "pointer", alignSelf: "flex-start" }}
                                                onClick={handleDeleteSample}
                                            />
                                        </Box>
                                        <ul>
                                            {sample.questions.map((question, qIndex) => (
                                                <li key={qIndex}>
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        <Typography variant="body1">Q{question.questionNumber}</Typography>
                                                        <FormControl size="small" sx={{ minWidth: 80, ml: 1 }}>
                                                            <Select
                                                                value={question.question_type || 'mcq'}
                                                                onChange={(e) => handleQuestionTypeChange(null, qIndex, e.target.value)}
                                                                sx={{ fontSize: '0.75rem', height: 28 }}
                                                            >
                                                                <MenuItem value="mcq">MCQ</MenuItem>
                                                                <MenuItem value="sa">SA</MenuItem>
                                                                <MenuItem value="frq">FRQ</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        {(!question.question_type || question.question_type === 'mcq') && (
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        size="small"
                                                                        checked={question.isMultiSelect || false}
                                                                        onChange={() => handleSampleMultiSelectToggle(qIndex)}
                                                                    />
                                                                }
                                                                label={<Typography variant="caption">Multi</Typography>}
                                                                sx={{ ml: 1 }}
                                                            />
                                                        )}
                                                    </Box>
                                                    {question.question_type === 'sa' ? (
                                                        <Box sx={{ ml: 2, p: 1, border: '1px dashed #4cceac', borderRadius: 1 }}>
                                                            <Typography variant="caption" color="text.secondary">Accepted Answers (first = display answer):</Typography>
                                                            {(question.accepted_answers || ['']).map((alt, aIdx) => (
                                                                <Box key={aIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                                    <Typography variant="caption" sx={{ minWidth: 16, color: aIdx === 0 ? colors.greenAccent[400] : colors.grey[500] }}>{aIdx + 1}.</Typography>
                                                                    <TextField size="small" value={alt}
                                                                        placeholder={aIdx === 0 ? 'Primary answer' : `Alternate ${aIdx}`}
                                                                        onChange={(e) => {
                                                                            const newAlts = [...(question.accepted_answers || [''])];
                                                                            newAlts[aIdx] = e.target.value;
                                                                            const updatedQuestions = sample.questions.map((q, qi) =>
                                                                                qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q
                                                                            );
                                                                            setSample({ ...sample, questions: updatedQuestions });
                                                                        }}
                                                                        sx={{ flex: 1 }}
                                                                    />
                                                                    {(question.accepted_answers || ['']).length > 1 && (
                                                                        <IconButton size="small" onClick={() => {
                                                                            const newAlts = (question.accepted_answers || ['']).filter((_, i) => i !== aIdx);
                                                                            const updatedQuestions = sample.questions.map((q, qi) =>
                                                                                qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q
                                                                            );
                                                                            setSample({ ...sample, questions: updatedQuestions });
                                                                        }}>
                                                                            <ClearIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}
                                                                </Box>
                                                            ))}
                                                            <Button size="small" onClick={() => {
                                                                const newAlts = [...(question.accepted_answers || ['']), ''];
                                                                const updatedQuestions = sample.questions.map((q, qi) =>
                                                                    qi === qIndex ? { ...q, accepted_answers: newAlts } : q
                                                                );
                                                                setSample({ ...sample, questions: updatedQuestions });
                                                            }}>+ Add</Button>
                                                        </Box>
                                                    ) : question.question_type === 'frq' ? (
                                                        <Box sx={{ ml: 2, p: 1, border: '1px dashed #999', borderRadius: 1 }}>
                                                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                                                    <InputLabel>FRQ Type</InputLabel>
                                                                    <Select value={question.frq_type || 'saq'} label="FRQ Type"
                                                                        onChange={(e) => updateQuestionFrqField(null, qIndex, 'frq_type', e.target.value)}>
                                                                        <MenuItem value="saq">SAQ</MenuItem>
                                                                        <MenuItem value="dbq">DBQ</MenuItem>
                                                                        <MenuItem value="leq">LEQ</MenuItem>
                                                                        <MenuItem value="upload">Upload</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                                {(() => {
                                                                    const partsSum = question.frq_type === 'saq' && question.frq_parts
                                                                        ? question.frq_parts.reduce((s, p) => s + (p.max_points || 0), 0) : null;
                                                                    const mismatch = partsSum !== null && question.max_points !== partsSum;
                                                                    return (
                                                                        <TextField size="small" label="Max Points" type="number"
                                                                            value={question.max_points || ''} sx={{ width: 100 }}
                                                                            error={mismatch}
                                                                            helperText={mismatch ? `Parts sum: ${partsSum}` : ''}
                                                                            onChange={(e) => updateQuestionFrqField(null, qIndex, 'max_points', parseInt(e.target.value) || 0)} />
                                                                    );
                                                                })()}
                                                                <TextField size="small" label="Choice Group" type="number"
                                                                    value={question.choice_group || ''} sx={{ width: 120 }}
                                                                    onChange={(e) => updateQuestionFrqField(null, qIndex, 'choice_group', parseInt(e.target.value) || null)} />
                                                            </Box>
                                                            {(question.frq_type === 'saq' || question.frq_type === 'upload') && question.frq_parts && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                                                    <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>Parts:</Typography>
                                                                    {question.frq_parts.map((part, pIdx) => (
                                                                        <Box key={pIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                                                            <TextField size="small" value={part.part_label}
                                                                                sx={{ width: 45 }}
                                                                                inputProps={{ style: { padding: '2px 4px', fontSize: '0.75rem', fontWeight: 'bold' } }}
                                                                                onChange={(e) => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], part_label: e.target.value };
                                                                                    updateFrqParts(null, qIndex, updated);
                                                                                }} />
                                                                            <TextField size="small" type="number" value={part.max_points}
                                                                                sx={{ width: 50 }}
                                                                                inputProps={{ min: 0, style: { padding: '2px 6px', fontSize: '0.75rem' } }}
                                                                                onChange={(e) => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], max_points: parseInt(e.target.value) || 0 };
                                                                                    updateFrqParts(null, qIndex, updated);
                                                                                }} />
                                                                            <Typography variant="caption" color="text.secondary">pt</Typography>
                                                                            <Typography variant="caption"
                                                                                onClick={() => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], part_type: part.part_type === 'upload' ? 'text' : 'upload' };
                                                                                    updateFrqParts(null, qIndex, updated);
                                                                                }}
                                                                                sx={{ cursor: 'pointer', px: 0.5, borderRadius: 0.5, fontSize: '0.6rem',
                                                                                    backgroundColor: part.part_type === 'upload' ? '#e3f2fd' : 'transparent',
                                                                                    color: part.part_type === 'upload' ? '#1565c0' : 'text.secondary',
                                                                                    border: '1px solid', borderColor: part.part_type === 'upload' ? '#1565c0' : 'transparent',
                                                                                    '&:hover': { backgroundColor: '#e3f2fd' } }}>
                                                                                {part.part_type === 'upload' ? 'IMG' : 'TXT'}
                                                                            </Typography>
                                                                        </Box>
                                                                    ))}
                                                                    <Button size="small" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                        onClick={() => {
                                                                            const nextLabel = String.fromCharCode(97 + question.frq_parts.length);
                                                                            updateFrqParts(null, qIndex, [...question.frq_parts, { part_label: nextLabel, max_points: 1 }]);
                                                                        }}>+</Button>
                                                                    {question.frq_parts.length > 1 && (
                                                                        <Button size="small" color="error" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                            onClick={() => updateFrqParts(null, qIndex, question.frq_parts.slice(0, -1))}>−</Button>
                                                                    )}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    ) : (
                                                    <ul>
                                                        {question.isMultiSelect ? (
                                                            <FormGroup row>
                                                                {question.choices.map((choice, cIndex) => (
                                                                    <FormControlLabel
                                                                        key={cIndex}
                                                                        control={
                                                                            <Checkbox
                                                                                checked={(question.answer || '').split(',').includes(choice.choice)}
                                                                                onChange={() => handleSampleAnswerChange(qIndex, choice.choice, true)}
                                                                            />
                                                                        }
                                                                        label={choice.choice}
                                                                    />
                                                                ))}
                                                            </FormGroup>
                                                        ) : (
                                                            <RadioGroup
                                                                row
                                                                value={question.answer}
                                                                onChange={(e) => handleSampleAnswerChange(qIndex, e.target.value)}
                                                            >
                                                                {question.choices.map((choice, cIndex) => (
                                                                    <FormControlLabel key={cIndex} value={choice.choice} control={<Radio />} label={choice.choice} />
                                                                ))}
                                                            </RadioGroup>
                                                        )}
                                                    </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )
                            )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                    {numQuestions && numChoices && (<>
                        <Box
                            sx={{
                                position: 'fixed',
                                top: '15%',
                                right: !previewCardToggle ? 40 : -200,
                                transform: 'translateY(-50%)',
                                zIndex: 101,
                                transition: 'right 0.5s',
                                minWidth: 400,
                                maxWidth: 550,
                            }}
                        >
                            <IconButton
                                onClick={() => setPreviewCardToggle(!previewCardToggle)}
                            >
                                {previewCardToggle ?
                                <h4>Show Preview</h4> : <h4>Hide</h4>
                                }
                                {previewCardToggle ?
                                <KeyboardDoubleArrowLeftIcon fontSize='large' /> :
                                <KeyboardDoubleArrowRightIcon fontSize='large' />}
                            </IconButton>
                        </Box>
                        <Box
                            sx={{
                                position: 'fixed',
                                top: '42%',
                                right: !previewCardToggle ? 40 : -350,
                                transform: 'translateY(-50%)',
                                backgroundColor: colors.primary[600],
                                border: `5px solid ${colors.grey[800]}`,
                                boxShadow: 10,
                                zIndex: 100,
                                padding: 2,
                                transition: 'right 0.5s',
                                height: "50%",
                                width: 400,
                                overflowX: 'hidden',
                                overflowY: 'auto',
                            }}
                        >
                            {((isSection?.value === "No Section" && sampleCreated && selectedSectionIndex === 0) ||
                              (isSection?.value === "With Section" && sectionCreated && selectedSectionIndex !== null)) ? (
                                <>
                                    <QuestionPreviewForTest numChoices={previewNumChoices} setNumChoices={setPreviewNumChoices} setOptionName={setPreviewOptionName} optionName={previewOptionName} readOnlyNames={useActStyleChoices}/>
                                    <Typography variant="caption" sx={{ mt: 1, color: colors.grey[400], display: "block" }}>
                                        {useActStyleChoices
                                            ? "Choice labels are set automatically (A,B,C,D / F,G,H,J). You can add or remove choices."
                                            : isSection?.value === "No Section"
                                                ? "Changes here will automatically update the sample below."
                                                : `Changes here will update Section ${selectedSectionIndex + 1}.`
                                        }
                                    </Typography>
                                </>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        color: colors.grey[400],
                                    }}
                                >
                                    <Typography variant="h6" textAlign="center">
                                        {isSection?.value === "No Section"
                                            ? "Create a sample to see preview"
                                            : "Select a section to see preview"
                                        }
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </>)}
                 
                    <Box
                        sx={{ 
                            display: "flex", 
                            flexDirection: "row", 
                            gap: "10px", 
                            mt: 2, 
                            p: 2, 
                            bgcolor: colors.primary[600], 
                            borderRadius: 2, 
                            boxShadow: 3,
                        }}
                    >
                        <FormControl>
                            <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="sections" direction="horizontal" type="SECTION">
                                    {(provided) => (
                                        <Box
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                gap: 2,
                                            }}
                                        >
                                            {isSection?.value === "With Section" && sections && sections.length > 0 && sections.map((section, sectionIndex) => (
                                                <Draggable key={sectionIndex} draggableId={`section-${sectionIndex}`} index={sectionIndex}>
                                                    {(provided, snapshot) => (
                                                        <Box
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={() => setSelectedSectionIndex(selectedSectionIndex === sectionIndex ? null : sectionIndex)}
                                                            sx={{
                                                                minWidth: "400px",
                                                                maxWidth: "400px",
                                                                flex: 1,
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                p: 2,
                                                                bgcolor: snapshot.isDragging ? colors.primary[600] : colors.primary[700],
                                                                borderRadius: 2,
                                                                width: "100%",
                                                                boxShadow: snapshot.isDragging ? 6 : 3,
                                                                cursor: "grab",
                                                                border: selectedSectionIndex === sectionIndex ? `3px solid ${colors.blueAccent[400]}` : "3px solid transparent",
                                                                transition: "border 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                                                '&:hover': {
                                                                    border: selectedSectionIndex === sectionIndex ? `3px solid ${colors.blueAccent[400]}` : `3px solid ${colors.grey[500]}`,
                                                                }
                                                            }}
                                                        >
                                                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                                <Box>
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                        <TextField
                                                                            label="Section Name"
                                                                            variant="outlined"
                                                                            value={section.section_name ? section.section_name : ``}
                                                                            onChange={(e) => handleSectionNameChange(e, sectionIndex)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                        {selectedSectionIndex === sectionIndex && (
                                                                            <Box
                                                                                sx={{
                                                                                    bgcolor: colors.blueAccent[500],
                                                                                    color: "white",
                                                                                    px: 1,
                                                                                    py: 0.25,
                                                                                    borderRadius: 1,
                                                                                    fontSize: "0.7rem",
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                            >
                                                                                Selected
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                    <Typography variant="body1">{section.numQuestions} questions</Typography>
                                                                </Box>
                                                                <ClearIcon
                                                                    fontSize='small'
                                                                    color='error'
                                                                    sx={{ cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleClickDialogOpen(sectionIndex);
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{height: "100%"}}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <ul>
                                                                    {section.questions.map((question, qIndex) => (
                                                                        <li key={qIndex}>
                                                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                                <Typography variant="body1">Q{question.questionNumber}</Typography>
                                                                                <FormControl size="small" sx={{ minWidth: 80, ml: 1 }}>
                                                                                    <Select
                                                                                        value={question.question_type || 'mcq'}
                                                                                        onChange={(e) => handleQuestionTypeChange(sectionIndex, qIndex, e.target.value)}
                                                                                        sx={{ fontSize: '0.75rem', height: 28 }}
                                                                                    >
                                                                                        <MenuItem value="mcq">MCQ</MenuItem>
                                                                                        <MenuItem value="sa">SA</MenuItem>
                                                                                        <MenuItem value="frq">FRQ</MenuItem>
                                                                                    </Select>
                                                                                </FormControl>
                                                                                {(!question.question_type || question.question_type === 'mcq') && (
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Switch
                                                                                                size="small"
                                                                                                checked={question.isMultiSelect || false}
                                                                                                onChange={() => handleSectionMultiSelectToggle(sectionIndex, qIndex)}
                                                                                            />
                                                                                        }
                                                                                        label={<Typography variant="caption">Multi</Typography>}
                                                                                        sx={{ ml: 1 }}
                                                                                    />
                                                                                )}
                                                                            </Box>
                                                                            {question.question_type === 'sa' ? (
                                                                                <Box sx={{ ml: 2, p: 1, border: '1px dashed #4cceac', borderRadius: 1 }}>
                                                                                    <Typography variant="caption" color="text.secondary">Accepted Answers (first = display answer):</Typography>
                                                                                    {(question.accepted_answers || ['']).map((alt, aIdx) => (
                                                                                        <Box key={aIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                                                            <Typography variant="caption" sx={{ minWidth: 16, color: aIdx === 0 ? colors.greenAccent[400] : colors.grey[500] }}>{aIdx + 1}.</Typography>
                                                                                            <TextField size="small" value={alt}
                                                                                                placeholder={aIdx === 0 ? 'Primary answer' : `Alternate ${aIdx}`}
                                                                                                onChange={(e) => {
                                                                                                    const newAlts = [...(question.accepted_answers || [''])];
                                                                                                    newAlts[aIdx] = e.target.value;
                                                                                                    const updatedSections = sections.map((s, si) =>
                                                                                                        si === sectionIndex ? { ...s, questions: s.questions.map((q, qi) =>
                                                                                                            qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q) } : s
                                                                                                    );
                                                                                                    setSections(updatedSections);
                                                                                                }}
                                                                                                sx={{ flex: 1 }}
                                                                                            />
                                                                                            {(question.accepted_answers || ['']).length > 1 && (
                                                                                                <IconButton size="small" onClick={() => {
                                                                                                    const newAlts = (question.accepted_answers || ['']).filter((_, i) => i !== aIdx);
                                                                                                    const updatedSections = sections.map((s, si) =>
                                                                                                        si === sectionIndex ? { ...s, questions: s.questions.map((q, qi) =>
                                                                                                            qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q) } : s
                                                                                                    );
                                                                                                    setSections(updatedSections);
                                                                                                }}>
                                                                                                    <ClearIcon fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                        </Box>
                                                                                    ))}
                                                                                    <Button size="small" onClick={() => {
                                                                                        const newAlts = [...(question.accepted_answers || ['']), ''];
                                                                                        const updatedSections = sections.map((s, si) =>
                                                                                            si === sectionIndex ? { ...s, questions: s.questions.map((q, qi) =>
                                                                                                qi === qIndex ? { ...q, accepted_answers: newAlts } : q) } : s
                                                                                        );
                                                                                        setSections(updatedSections);
                                                                                    }}>+ Add</Button>
                                                                                </Box>
                                                                            ) : question.question_type === 'frq' ? (
                                                                                <Box sx={{ ml: 2, p: 1, border: '1px dashed #999', borderRadius: 1 }}>
                                                                                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                                                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                                                                            <InputLabel>FRQ Type</InputLabel>
                                                                                            <Select value={question.frq_type || 'saq'} label="FRQ Type"
                                                                                                onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'frq_type', e.target.value)}>
                                                                                                <MenuItem value="saq">SAQ</MenuItem>
                                                                                                <MenuItem value="dbq">DBQ</MenuItem>
                                                                                                <MenuItem value="leq">LEQ</MenuItem>
                                                                                                <MenuItem value="upload">Upload</MenuItem>
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                        {(() => {
                                                                                            const partsSum = question.frq_type === 'saq' && question.frq_parts
                                                                                                ? question.frq_parts.reduce((s, p) => s + (p.max_points || 0), 0) : null;
                                                                                            const mismatch = partsSum !== null && question.max_points !== partsSum;
                                                                                            return (
                                                                                                <TextField size="small" label="Max Points" type="number"
                                                                                                    value={question.max_points || ''} sx={{ width: 100 }}
                                                                                                    error={mismatch}
                                                                                                    helperText={mismatch ? `Parts sum: ${partsSum}` : ''}
                                                                                                    onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'max_points', parseInt(e.target.value) || 0)} />
                                                                                            );
                                                                                        })()}
                                                                                        <TextField size="small" label="Choice Group" type="number"
                                                                                            value={question.choice_group || ''} sx={{ width: 120 }}
                                                                                            onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'choice_group', parseInt(e.target.value) || null)} />
                                                                                    </Box>
                                                                                    {(question.frq_type === 'saq' || question.frq_type === 'upload') && question.frq_parts && (
                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                                                                            <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>Parts:</Typography>
                                                                                            {question.frq_parts.map((part, pIdx) => (
                                                                                                <Box key={pIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                                                                                    <TextField size="small" value={part.part_label}
                                                                                sx={{ width: 45 }}
                                                                                inputProps={{ style: { padding: '2px 4px', fontSize: '0.75rem', fontWeight: 'bold' } }}
                                                                                onChange={(e) => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], part_label: e.target.value };
                                                                                    updateFrqParts(sectionIndex, qIndex, updated);
                                                                                }} />
                                                                                                    <TextField size="small" type="number" value={part.max_points}
                                                                                                        sx={{ width: 50 }}
                                                                                                        inputProps={{ min: 0, style: { padding: '2px 6px', fontSize: '0.75rem' } }}
                                                                                                        onChange={(e) => {
                                                                                                            const updated = [...question.frq_parts];
                                                                                                            updated[pIdx] = { ...updated[pIdx], max_points: parseInt(e.target.value) || 0 };
                                                                                                            updateFrqParts(sectionIndex, qIndex, updated);
                                                                                                        }} />
                                                                                                    <Typography variant="caption" color="text.secondary">pt</Typography>
                                                                                                    <Typography variant="caption"
                                                                                                        onClick={() => {
                                                                                                            const updated = [...question.frq_parts];
                                                                                                            updated[pIdx] = { ...updated[pIdx], part_type: part.part_type === 'upload' ? 'text' : 'upload' };
                                                                                                            updateFrqParts(sectionIndex, qIndex, updated);
                                                                                                        }}
                                                                                                        sx={{ cursor: 'pointer', px: 0.5, borderRadius: 0.5, fontSize: '0.6rem',
                                                                                                            backgroundColor: part.part_type === 'upload' ? '#e3f2fd' : 'transparent',
                                                                                                            color: part.part_type === 'upload' ? '#1565c0' : 'text.secondary',
                                                                                                            border: '1px solid', borderColor: part.part_type === 'upload' ? '#1565c0' : 'transparent',
                                                                                                            '&:hover': { backgroundColor: '#e3f2fd' } }}>
                                                                                                        {part.part_type === 'upload' ? 'IMG' : 'TXT'}
                                                                                                    </Typography>
                                                                                                </Box>
                                                                                            ))}
                                                                                            <Button size="small" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                                                onClick={() => {
                                                                                                    const nextLabel = String.fromCharCode(97 + question.frq_parts.length);
                                                                                                    updateFrqParts(sectionIndex, qIndex, [...question.frq_parts, { part_label: nextLabel, max_points: 1 }]);
                                                                                                }}>+</Button>
                                                                                            {question.frq_parts.length > 1 && (
                                                                                                <Button size="small" color="error" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                                                    onClick={() => updateFrqParts(sectionIndex, qIndex, question.frq_parts.slice(0, -1))}>−</Button>
                                                                                            )}
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            ) : (
                                                                            <ul>
                                                                                {question.isMultiSelect ? (
                                                                                    <FormGroup row>
                                                                                        {question.choices.map((choice, cIndex) => (
                                                                                            <FormControlLabel
                                                                                                key={cIndex}
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={(question.answer || '').split(',').includes(choice.choice)}
                                                                                                        onChange={() => handleSectionAnswerChange(sectionIndex, qIndex, choice.choice, true)}
                                                                                                    />
                                                                                                }
                                                                                                label={choice.choice}
                                                                                            />
                                                                                        ))}
                                                                                    </FormGroup>
                                                                                ) : (
                                                                                    <RadioGroup
                                                                                        row
                                                                                        value={question.answer}
                                                                                        onChange={(e) => handleSectionAnswerChange(sectionIndex, qIndex, e.target.value)}
                                                                                    >
                                                                                        {question.choices.map((choice, cIndex) => (
                                                                                            <FormControlLabel key={cIndex} value={choice.choice} control={<Radio />} label={choice.choice} />
                                                                                        ))}
                                                                                    </RadioGroup>
                                                                                )}
                                                                            </ul>
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Box>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </FormControl>
                        
                        <Dialog
                            open={dialogOpen}
                            onClose={handleDialogClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Do you want to delete this section?"}
                            </DialogTitle>
                            <DialogActions>
                                <Button onClick={handleDeleteSection} color="warning" autoFocus>
                                    Yes
                                </Button>
                                <Button onClick={handleDialogClose}>No</Button>
                            </DialogActions>
                        </Dialog>

                        {/* Auto-fill Confirmation Modal */}
                        <Dialog
                            open={autoFillModalOpen}
                            onClose={() => setAutoFillModalOpen(false)}
                            maxWidth="xs"
                            fullWidth
                        >
                            <DialogTitle>Auto-fill with AI</DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    Choose which files to send to GPT-4o for analysis. Sending fewer files is faster.
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={autoFillSendTest}
                                            onChange={(e) => setAutoFillSendTest(e.target.checked)}
                                            disabled={!file}
                                        />
                                    }
                                    label={file ? `Test PDF: ${file.name}` : 'Test PDF (not uploaded)'}
                                />
                                <br />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={autoFillSendAnswerKey}
                                            onChange={(e) => setAutoFillSendAnswerKey(e.target.checked)}
                                            disabled={!rubricFile}
                                        />
                                    }
                                    label={rubricFile ? `Answer Key: ${rubricFile.name}` : 'Answer Key (not uploaded)'}
                                />
                                <br />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={autoFillSendRubric}
                                            onChange={(e) => setAutoFillSendRubric(e.target.checked)}
                                            disabled={!selectedRubricId}
                                        />
                                    }
                                    label={selectedRubricId
                                        ? `Rubric: ${existingRubrics.find(r => r.id === parseInt(selectedRubricId) || r.id === selectedRubricId)?.name || 'Selected'}`
                                        : 'Existing Rubric (none selected)'}
                                />
                                {isSaMode && autoFillSendAnswerKey && rubricFile && (
                                    <Typography variant="caption" color="success.main" sx={{ display: 'block', mt: 1 }}>
                                        SA mode: answer key alone is usually sufficient — no need to send the test PDF.
                                    </Typography>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setAutoFillModalOpen(false)}>Cancel</Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={(!autoFillSendTest || !file) && (!autoFillSendAnswerKey || !rubricFile) && (!autoFillSendRubric || !selectedRubricId)}
                                    onClick={handleOneClickAutoFill}
                                >
                                    Analyze
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* AI Auto-fill Dialog */}
                        <Dialog
                            open={aiDialogOpen}
                            onClose={() => setAiDialogOpen(false)}
                            maxWidth="md"
                            fullWidth
                        >
                            <DialogTitle>Auto-fill with AI</DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    1. Copy the prompt below and paste it into your AI tool along with the test PDF.
                                </Typography>
                                <Box sx={{ position: 'relative', mb: 2 }}>
                                    <TextField
                                        multiline
                                        rows={6}
                                        fullWidth
                                        value={AI_PROMPT}
                                        InputProps={{
                                            readOnly: true,
                                            sx: {
                                                fontSize: '0.75rem',
                                                fontFamily: 'monospace',
                                                '& textarea': {
                                                    scrollbarWidth: 'none',
                                                    '&::-webkit-scrollbar': { display: 'none' },
                                                },
                                            }
                                        }}
                                    />
                                    <IconButton
                                        size="small"
                                        sx={{ position: 'absolute', top: 8, right: 8 }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(AI_PROMPT);
                                            setSuccessAlertMessage("Prompt copied to clipboard");
                                            setSuccessAlertOpen(true);
                                        }}
                                    >
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    2. Paste the AI's JSON response below:
                                </Typography>
                                <TextField
                                    multiline
                                    rows={10}
                                    fullWidth
                                    placeholder='Paste the JSON response here...'
                                    value={aiResponseText}
                                    onChange={(e) => setAiResponseText(e.target.value)}
                                    InputProps={{ sx: { fontSize: '0.8rem', fontFamily: 'monospace' } }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => { setAiDialogOpen(false); setAiResponseText(''); }}>Cancel</Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={!aiResponseText.trim()}
                                    onClick={handleApplyAiResponse}
                                >
                                    Apply
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                    
                    <Box display="flex" justifyContent="start" mt="20px" gap={2}>
                        <Button type="submit" color="secondary" variant="contained">
                            Create New Test
                        </Button>
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<VisibilityIcon />}
                            onClick={() => setPreviewDialogOpen(true)}
                        >
                            Student Preview
                        </Button>
                    </Box>
                </form>
                )}
            </Formik>
            <Alert
                successAlertOpen={successAlertOpen}
                setSuccessAlertOpen={setSuccessAlertOpen}
                errorAlertOpen={errorAlertOpen}
                setErrorAlertOpen={setErrorAlertOpen}
                successMsg={successAlertMessage}
                errorMsg={errorAlertMessage}
                vertical="bottom"
                horizontal="left"
            />
            <Backdrop backdropOpen={backdropOpen} handleBackdropClose={handleBackdropClose} />
            <HiddenPDF documentRender={documentRender} />
            <TestPreviewDialog
                open={previewDialogOpen}
                onClose={() => setPreviewDialogOpen(false)}
                hasSection={isSection?.value === "With Section"}
                sections={sections}
                sample={sample}
                testTitle={file?.name}
            />
        </Box>
    );
};

const checkoutSchema = yup.object().shape({
    pages: yup.number().required("required"),
    questions: yup.number().required("required"),
    choices: yup.number().nullable(),
});

const initialValues = {
    pages: 0,
    questions: 0,
    choices: 0,
};

export default AddTest